import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionCreators } from "../../_actions/ActionCreators";
import CarrinhoService from "../../services/CarrinhoService";
import { PagamentoProcessandoContentStyle } from "./style";
import AutenticacaoService from "../../services/AutenticacaoService";
import CheckoutTransparenteService from "../../services/CheckoutTransparenteService";
import TagueamentoService from "../../services/TagueamentoService";

const tagueamentoService = new TagueamentoService();

function PagamentoProcessandoCartao({
  tipoPagamento: tipoPagamentoProp = "cartao_credito",
  fretesCarinho = [],
  inserirCreditos = false,
  card,
  somaValorTotalFretes,
  saldo = null,
  uuidCarinho = null,
}) {
  const dispatch = useDispatch();
  const carrinhoService = new CarrinhoService();
  const checkoutTransparenteService = new CheckoutTransparenteService();

  const [erro, setErro] = useState(null);
  const [sucesso, setSucesso] = useState(false);
  const [loading, setLoading] = useState(true);

  let { splitPayment } = useSelector((state) => {
    return {
      splitPayment: state.splitPayment,
    };
  });

  const tipoPagamento = splitPayment
    ? "carteira_flex+cartao_credito"
    : tipoPagamentoProp || "cartao_credito";

  const authService = new AutenticacaoService();
  useEffect(() => {
    if (!card) {
      setErro("Dados do pagamento incompletos.");
      setLoading(false);
      return;
    }

    const amount = Number(somaValorTotalFretes.toFixed(2));
    const currency = "BRL";

    const currentUser = authService.usuarioCorrente();
    const customer = currentUser ? { uuid: currentUser.identificadorAssinatura } : null;

    const cardData = card.isSavedCard
      ? {
          token: card.uuid || card.token,
          saveCard: false,
          securityCode: card.securityCode,
          brand: card.brand,
          customer,
        }
      : {
          cardName: card.cardName,
          token: card.token || null,
          saveCard: card.saveCard ?? true,
          customer,
          cardNumber: card.cardNumber,
          brand: card.brand,
          holder: card.holder,
          expirationDate: card.expirationDate.replace(/(\d{2})\/(\d{2})/, "$1/20$2"),
          securityCode: card.securityCode,
        };

    checkoutTransparenteService.PagarComCartao(
      uuidCarinho,
      amount,
      saldo,
      currency,
      cardData,
      splitPayment,
      (error, data) => {
        setLoading(false);

        if (error) {
          setErro(error.message || "Erro ao processar pagamento.");
          return;
        }

        if (data) {
          if (inserirCreditos === false) {
            tagueamentoService.eventoMarketingCheckoutTransparente(
              fretesCarinho,
              tipoPagamento,
              amount,
              data.paymentId,
              uuidCarinho
            );
          }
          carrinhoService.deleteCalculadoraFormInfo();
          dispatch(ActionCreators.setFreteCompradoComSucesso({}));
          dispatch(ActionCreators.setCarrinhoInformacoes([]));
          carrinhoService.setNumeroItensInfosParaCompra(0);
          setSucesso(true);
          return;
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, card, somaValorTotalFretes]);

  return (
    <PagamentoProcessandoContentStyle>
      <div className="content">
        {loading && (
          <>
            <div className="spinner" />
            <p>O seu pagamento está sendo processado...</p>
          </>
        )}

        {!loading && !erro && !sucesso && (
          <>
            <div className="icon pending">!</div>
            <h2>O seu pagamento está pendente.</h2>

            <p>{erro}</p>
            <button onClick={() => (window.location.href = "/carteira")}>Carteira flex</button>
          </>
        )}

        {erro && (
          <>
            <div className="icon error">✕</div>
            <h2>
              O seu pagamento <b>não</b> foi confirmado.
            </h2>
            <p>Motivo: {erro}</p>
            <button onClick={() => window.location.reload()}>Voltar</button>
          </>
        )}

        {sucesso && (
          <>
            <div className="icon success">✓</div>
            <h2>O seu pagamento já foi confirmado!</h2>
            <button
              onClick={() =>
                inserirCreditos
                  ? (window.location.href = "/home")
                  : (window.location.href = "/envios")
              }
            >
              {inserirCreditos ? "Voltar" : "Meus Fretes"}
            </button>
          </>
        )}
      </div>
    </PagamentoProcessandoContentStyle>
  );
}

export default PagamentoProcessandoCartao;
